module.exports = __webpack_public_path__ + "static/media/Mail.d8d9456b.svg";